import React from 'react';
import { withTheme } from 'styled-components';

import Completed from '../icons/Completed';
import New from '../icons/New';
import Started from '../icons/Started';
import ThemeStatus from './ThemeStatus';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

const PRODUCT_FOCUS_STATUS_NEW = 'product_focus_new';
const PRODUCT_FOCUS_STATUS_STARTED = 'product_focus_started';
const PRODUCT_FOCUS_STATUS_COMPLETED = 'product_focus_completed';

const statusIcons = {
  [PRODUCT_FOCUS_STATUS_NEW]: props => <New {...props} />,
  [PRODUCT_FOCUS_STATUS_STARTED]: props => <Started {...props} />,
  [PRODUCT_FOCUS_STATUS_COMPLETED]: props => <Completed {...props} />,
};

export default withTheme(({ status, color, iconStyle, small, ...props }) => {
  return (
    <ThemeStatus statusIcons={statusIcons} status={status} {...props} iconStyle={{
      width: small ? '1.5rem' : '2rem',
    }} />
  );
});


